module.exports = __webpack_public_path__ + "img/registerImage.f14788e1.png";